import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import ApplicationLayout from "components/layout/ApplicationLayout";
import style from "components/layout/layout.scss";
import { LoadingIndicator } from "components/loading-indicator/LoadingIndicator";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import Products from "components/products/Products";
import { HOME_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";
import { useIsAiHomeEnabled } from "services/feature/useIsAiHomeEnabled";
import { StoreState } from "store";

const AIPanel = React.lazy(() => import("components/ai-panel/AIPanel").then((module) => ({ default: module.AIPanel })));

export default function HomeView(): JSX.Element {
    const { t } = useTranslation();
    const isAiHomeEnabled = useIsAiHomeEnabled();

    const tenantDetails = useSelector(
        (state: StoreState) => state.tenantDetailsReducer.stack[state.tenantDetailsReducer.stack.length - 1]
    );

    const [showVideoModal, setShowVideoModal] = React.useState(false);
    const watchTutorialButton =
        tenantDetails && tenantDetails.contractType !== "TRIAL" ? (
            <VideoTutorialButton onClick={() => setShowVideoModal(true)} />
        ) : undefined;

    return (
        <>
            <ApplicationLayout
                viewTitle={!isAiHomeEnabled ? t("Routes.yourProducts") : undefined}
                view={
                    isAiHomeEnabled ? (
                        <React.Suspense fallback={<LoadingIndicator isView />}>
                            <AIPanel layout={"subMenu"} />
                        </React.Suspense>
                    ) : (
                        <Products />
                    )
                }
                mainRoute={HOME_ROUTE}
                viewActions={!isAiHomeEnabled ? watchTutorialButton : undefined}
                hideActions={!isAiHomeEnabled ? watchTutorialButton : undefined}
                className={isAiHomeEnabled ? style.fullscreen : undefined}
                isAiHomeView={isAiHomeEnabled}
            />
            {!isAiHomeEnabled && (
                <VideoModal
                    isOpen={showVideoModal}
                    hideModal={() => setShowVideoModal(false)}
                    linkUrl={TutorialVideoLink.HOME}
                />
            )}
        </>
    );
}
